// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function(props, state)
{
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
	{
		return true;
	}
	const {fields, validFields} = state;

	for (const name in validFields)
	{
		if (validFields[name] === false)
		{
			return false;
		}
	}

	if (state.isCompany)
	{
		return !!(
			fields.customer_firstname.length > 0
			&& Validator.validateOrgNum(fields.customer_social_security_number, true)
			&& fields.signatory_fields_valid
		);
	}

	return !!(
		fields.customer_firstname.length > 0
		&& fields.customer_lastname.length > 0
		&& Validator.validateSsn(fields.customer_social_security_number)
		&& Validator.validateEmail(fields.customer_email)
	);

}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/fair-kyc/CustomerInformation.fulfillment.js